import { apiEndpoint, getCurrentEnvironment, getHostName } from '../../apiEndpoint/apiEndpoint.js';
import { failover } from './failover.js';

var instances;
var apiHostName = getHostName();
var apiEndPointsMap = apiEndpoint(apiHostName);
if (getCurrentEnvironment(apiHostName) === 'local') {
  instances = ['http://localhost:4000', 'http://localhost:4000'];
} else if (apiHostName.includes('gatewatch')) {
  instances = ['https://galactica-mypages-api01.dev.verisure.com', 'https://galactica-mypages-api02.dev.verisure.com'];
} else {
  instances = [apiEndPointsMap.primary, apiEndPointsMap.failover];
}
var withFailover = failover(instances);
var fetchWithFailover = function fetchWithFailover(url, data) {
  return withFailover(url, data);
};

export { fetchWithFailover };
